module.exports = __webpack_public_path__ + "static/card-project4-282e960fb4799f1571f8df66d8bc7f40.jpg";